<template>
  <v-card outlined max-width="380" class="mb-5">
    <v-card-subtitle>
      <PostStatus :post="post" />
    </v-card-subtitle>
    <v-divider />

    <template
      v-if="
        currentUser.permittedSituations.includes('post_publication') &&
        mode === 'edit'
      "
    >
      <v-card-text>
        <PublicationController :post="post" />
      </v-card-text>
      <v-divider />
    </template>

    <v-card-actions>
      <v-row class="px-5 mb-2">
        <PostPreviewBtn :post-id="post.id" :mode="mode" />
        <OrderDeliverBtn v-if="post.recentOrder" :order="post.recentOrder" />
        <PostSaveBtn v-if="mode !== 'readonly'" :post="post" />
        <DeletePostCacheBtn v-if="mode !== 'readonly'" :post="post" />
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import PostPreviewBtn from '../parts/PostPreviewBtn'
import OrderDeliverBtn from '../parts/OrderDeliverBtn'
import PostSaveBtn from '../parts/PostSaveBtn'
import DeletePostCacheBtn from '../parts/DeletePostCacheBtn'
import PostStatus from '../parts/PostStatus'
import PublicationController from '../parts/PublicationController'

export default {
  components: {
    PostPreviewBtn,
    PostSaveBtn,
    DeletePostCacheBtn,
    PostStatus,
    PublicationController,
    OrderDeliverBtn
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      mode: (state) => state.PostEditor.mode,
      currentUser: (state) => state.UserStore.currentUser
    })
  }
}
</script>
